import React from 'react'
import styled from 'styled-components'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import jessicaProfilePicture from '../assets/jessica-tacoen-profile.jpg'
import therapySessionSadness from '../assets/therapy-session-sadness.svg'
import workExperience from '../assets/work-experience-1.svg'
import {IoMdCheckboxOutline} from 'react-icons/io'
import OpacityAnimation from '../components/OpacityAnimation'
 
const AboutPage = () => {

  return (
    <Wrapper>
        <OpacityAnimation>
            <MDBContainer>
            {/* **************************************** Psicóloga Clínica e Psicoterapeuta em especialização */}
                <MDBRow className="pt-4 my-2">
                    <h3 className="font-weight-bold">Psicóloga Clínica e Psicoterapeuta em especialização</h3>
                    <hr />
                    <MDBCol md="12" lg="9" className="mt-4 section-items">
                        <p>Psicóloga clínica e psicoterapeuta psicanalítica em formação desde 2018, bem como psicoterapeuta de casal e família em formação.</p>
                        <p>Licenciatura e Mestrado em Psicologia Clínica Psicodinâmica desde 2013, pela Universidade de Lisboa.</p>
                        <p>Atualmente com prática clínica em consultório privado em Oeiras, Lisboa e online com crianças, adolescentes e adultos, em meio escolar com crianças e adolescentes e em meio profissional com funcionários de algumas empresas.</p>
                    </MDBCol>
                    <MDBCol md="12" lg="3" className="my-4 text-center">
                          <img src={jessicaProfilePicture} alt="profile pic" className="img-fluid profile-pic" />
                    </MDBCol>
                </MDBRow>

                {/* **************************************** Experiência profissional */}
                <MDBRow className="pt-4 my-2">
                    <h3 className="font-weight-bold">Experiência profissional</h3>
                    <hr />
                    <MDBCol md="12" lg="6" className="mt-4 section-items">
                      <p>Experiência profissional em Portugal e Angola: psicoterapia e avaliação psicológica de adultos, crianças e adolescentes com distúrbios psicológicos, atrasos de desenvolvimento e perturbações do espectro do autismo.</p>
                      <p>Exercício prévio da função de Psicóloga Clínica em escolas no Distrito de Lisboa e em Angola, assim como em Hospitais Públicos (Hospital de Egas Moniz & Hospital São Francisco Xavier).</p>
                      <p>Formação em Psicoterapia Psicanalítica Relacional (Psirelacional).</p>
                      <p>Formação em Psicoterapia de Casal e de Família em curso (Poiesis Analitika).</p>
                      <p>Formação em Intervenção com Crianças e Jovens em Risco (OPP).</p>
                      <p>Formação em Intervenção Psicológica em Problemas Ligados ao Álcool (OPP).</p>
                      <p>Formação em Intervenção Psicológica Com Pessoas LGBTQ (OPP).</p>
                      <p>Formação em Competências Socioemocionais em Jovens (OPP).</p>
                      <p>Formação em empreendedorismo (IPDJ).</p>
                      <p>Formadora certificada (IEFP).</p>
                      <p>Membro efetivo da Ordem dos Psicólogos Portugueses (nº 19425).</p>
                      <p>Membro associado da Associação de Psicanálise Relacional e da Poiesis Analitika.</p>
                    </MDBCol>
                    <MDBCol md="12" lg="6" className="my-4 text-center">
                          <img src={workExperience} alt="profile pic" className="img-fluid" />
                    </MDBCol>
                    <MDBCol sm="12" className="section-items">
                        
                    </MDBCol>
                </MDBRow>

                {/* **************************************** Área de atividade */}
                <MDBRow className="pt-4">
                    <h3 className="font-weight-bold">Área de atividade</h3>
                    <hr />
                    <MDBCol md="12" lg="6" className="my-4">
                        <p>Psicóloga Clínica e Psicoterapeuta Psicanalítica em especialização, dá consultas a crianças, adolescentes, adultos, casais e famílias.</p>
                        <p>Para obter mais informação ou marcar uma primeira consulta, por favor contacte-me.</p>
                        <ul className="about-check-list">
                            <li className="d-flex align-items-center"><IoMdCheckboxOutline /><span className="mt-1">Depressão;</span></li>
                            <li className="d-flex align-items-center"><IoMdCheckboxOutline /><span className="mt-1">Ansiedade;</span></li>
                            <li className="d-flex align-items-center"><IoMdCheckboxOutline /><span className="mt-1">Perturbações da Personalidade;</span></li>
                            <li className="d-flex align-items-center"><IoMdCheckboxOutline /><span className="mt-1">Ataques de pânico;</span></li>
                            <li className="d-flex align-items-center"><IoMdCheckboxOutline /><span className="mt-1">Fobias</span></li>
                            <li className="d-flex align-items-center"><IoMdCheckboxOutline /><span className="mt-1">Traumas;</span></li>
                            <li className="d-flex align-items-center"><IoMdCheckboxOutline /><span className="mt-1">Obsessões/Compulsões;</span></li>
                            <li className="d-flex align-items-center"><IoMdCheckboxOutline /><span className="mt-1">Baixa autoestima;</span></li>
                            <li className="d-flex align-items-center"><IoMdCheckboxOutline /><span className="mt-1">Processos de luto;</span></li>
                            <li className="d-flex align-items-center"><IoMdCheckboxOutline /><span className="mt-1">Distúrbios alimentares;</span></li>
                            <li className="d-flex align-items-center"><IoMdCheckboxOutline /><span className="mt-1">Problemas de sono;</span></li>
                            <li className="d-flex align-items-center"><IoMdCheckboxOutline /><span className="mt-1">Dificuldades na socialização / comunicação.</span></li>
                        </ul>
                        </MDBCol>
                        <MDBCol md="12" lg="6" className="my-4 d-flex align-sm-items-center">
                          <img src={therapySessionSadness} alt="therapy sadness" className="img-fluid" />
                        </MDBCol>
                    </MDBRow>
            </MDBContainer>
        </OpacityAnimation>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  margin-top: 8rem;
  margin-bottom: 8rem;
  background: var(--clr-white-smooth);
  .profile-pic{
    border-radius: 10px;
  }
  .about-check-list {
    svg {
      color: var(--website-main-color);
      font-size: 1.8rem;
      margin-right: 0.7rem;
    }
    li{
      font-size: 1.2rem;
      margin-top: 0.5rem;
    }
  }
  
  .section-items {
    p{
      border-left: 5px solid var(--website-main-color);
      padding-left: 0.6rem;
    }
  }
  @media (max-width: 600px) {
 
    .about-check-list {
      svg {
        font-size: 1.4rem;
        margin-right: 0.4rem;
      }
      li {
        font-size: 1rem;
        margin-top: 0.4rem;
      }
    }
}
`

export default AboutPage
